import { render } from "./instructionsview.vue?vue&type=template&id=68e329fc"
import script from "./instructionsview.vue?vue&type=script&lang=js"
export * from "./instructionsview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__